import {createBlockMarkdownSpec, mergeAttributes,} from '@tiptap/core'
import {Image} from '@tiptap/extension-image'



















export const ImageBlockBase = Image.extend({
  name: 'imageBlock',

  group: 'block',

  defining: true,

  isolating: true,

  addOptions() {
    return {
      editorWidth: 300,
      editorHeight: 112
    }
  },

  addStorage() {
    return {
      editorWidth: this.options.editorWidth,
      editorHeight: this.options.editorHeight
    }
  },

  parseHTML() {
    return [
      {
        tag: 'img[src]:not([src^="data:"])'
      }
    ]
  },
  renderText({node}) {
    const src = node.attrs.src 
    const fileName = src.split('/').pop()
    return `\n<<${fileName}>>\n`
  },
  renderHTML({HTMLAttributes}) {
    const align = HTMLAttributes['data-align']
    const justify = align === 'left' ? 'start' : align === 'right' ? 'end' : 'center'
    return [
      'div',
      {style: `width: 100%; display: flex; justify-content: ${justify};`},
      ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
    ]
  },
  ...createBlockMarkdownSpec({
    nodeName: 'imageBlock',
    serializeAttributes: ({alt, src}) => `[${alt || ''}](${src})`
  })
  // TipTap v3 got some types wrong, this cast shouldn't be necessary
} )
